module.exports = __webpack_public_path__ + "img/logo.9be86f87.png";